import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { DEALER_PROPS } from 'client/constants/dealer-reviews';
import { UserReview } from 'site-modules/dealerships/components/user-review/user-review';

export function ReviewListItems({ reviews, numVisible, params }) {
  return (
    <ul className="list-unstyled mb-0">
      {reviews.map((item, index) => (
        <li className={classnames('pt-1_5', { 'd-none': index >= numVisible })} key={item.id}>
          <UserReview review={item} params={params} index={index} />
          {index < numVisible - 1 && index !== reviews.length - 1 && <hr className="mt-1_5 mb-0" />}
        </li>
      ))}
    </ul>
  );
}

ReviewListItems.propTypes = {
  reviews: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  numVisible: PropTypes.number.isRequired,
  params: DEALER_PROPS.isRequired,
};
